import React from "react";

function Dashboard() {
  const boxes = [
    { title: "Total Users", details: ["Total Users: 3423", "Active: 106", "Inactive: 3317"], color: "#0d6efd" },
    { title: "Today's Users", details: ["Total: 0", "Active: 0", "Inactive: 0"], color: "#dc3545" },
    { title: "KYC Active Users", details: ["Today Active: 754"], color: "#6610f2" },
    { title: "KYC In-Active Users", details: ["Today In-Active: 2669"], color: "#20c997" },
    { title: "Add Wallet", details: ["Today Add: Rs. 214947245.61", "Today Online: Rs. 0"], color: "#6f42c1" },
    { title: "Wallet Withdrawal", details: ["Today: Rs. 85723683"], color: "#6c757d" },
    { title: "Wallet Transfer", details: ["Today Transfer: Rs. 66459089"], color: "#fd7e14" },
    { title: "ODH Money Redeem", details: ["Today Redeem: Rs. 5990"], color: "#e83e8c" },
    { title: "Recharge & Bill", details: ["Today: Rs. 3014329.35"], color: "#17a2b8" },
    { title: "Success Recharge", details: ["Today: Rs. 0"], color: "#198754" },
    { title: "Failed Recharge", details: ["Today: Rs. 0"], color: "#6c757d" },
  ];

  return (
    <div style={{ fontFamily: "Poppins, sans-serif", background: "#f8f9fa", padding: "20px" }}>
      <header style={{ marginBottom: "20px" }}>
        <h1 style={{ fontSize: "24px", marginBottom: "10px", color: "#333" }}>Dashboard</h1>
        <div style={{ display: "flex", gap: "15px" }}>
          <button
            style={{
              background: "#28a745",
              color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "0.3s",
            }}
            onMouseOver={(e) => (e.target.style.background = "#218838")}
            onMouseOut={(e) => (e.target.style.background = "#28a745")}
          >
            Member List Excel
          </button>
          <button
            style={{
              background: "#007bff",
              color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "0.3s",
            }}
            onMouseOver={(e) => (e.target.style.background = "#0056b3")}
            onMouseOut={(e) => (e.target.style.background = "#007bff")}
          >
            BBPS Balance: Rs. 2091.48
          </button>
        </div>
      </header>
      <div style={{ marginBottom: "20px", fontSize: "18px", fontWeight: "500" }}>
        Wallet Balance At User's Wallet: <span style={{ color: "#333" }}>Rs. 48334632.09</span>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "15px",
        }}
      >
        {boxes.map((box, index) => (
          <div
            key={index}
            style={{
              background: box.color,
              color: "#fff",
              borderRadius: "8px",
              padding: "20px",
              textAlign: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s, box-shadow 0.3s",
              cursor: "pointer",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
            }}
          >
            <h3 style={{ fontSize: "20px", marginBottom: "15px" }}>{box.title}</h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: "16px" }}>
              {box.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
